import type * as THREE from 'three';
import { Vector3 } from 'three';

export interface Projected {
  x: number; // pixels from viewport left
  y: number; // pixels from viewport top
  visible: boolean; // false when behind camera or outside frustum
}

// Module-scoped scratch vector to avoid per-call allocation. Browser is
// single-threaded so reuse is safe.
const _v = new Vector3();

export function projectWorldToScreen(
  world: readonly [number, number, number],
  camera: THREE.PerspectiveCamera,
  viewport: { width: number; height: number },
): Projected {
  _v.set(world[0], world[1], world[2]);
  _v.project(camera); // mutates _v to NDC space [-1, 1]
  const visible = _v.z >= -1 && _v.z <= 1 && _v.x >= -1 && _v.x <= 1 && _v.y >= -1 && _v.y <= 1;
  return {
    x: ((_v.x + 1) / 2) * viewport.width,
    y: ((1 - _v.y) / 2) * viewport.height, // flip Y (NDC up vs DOM down)
    visible,
  };
}
